/*
 * ─────────────────────────────────────────────────────────────────────────────
 * VECCHI FILE GESTIONE CORSI — sostituiti dalla gestione in
 * src/jsx/pages/struttura/corsi/. Non sono più raggiungibili dal menu: restano
 * solo per gli indirizzi diretti, finché non si decide di eliminarli.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Tab, Nav, Modal, Button, Spinner, Form, Alert } from "react-bootstrap";
import { Information, DollarSquare, CardAdd, Judge, Calendar, Warning2, Add, Trash} from "iconsax-react";
import { Link, useNavigate } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { sidSelectStyles } from "../../../../components/Util/sidSelectStyles";
import { sports, tipologiaStruttura } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";
import { useMemberships } from "../../../../../hooks/useMemberships";
import ProductImageUploader from "../../../../components/Util/ProductImageUploader";
import { VAT_OPTIONS, findVatOption, vatFieldsFromOption } from "../../../../components/Util/vatOptions";
import AvvisoFatturazione from '../../../../components/Util/AvvisoFatturazione';
import { segnalaMancanti } from '../../../../components/Util/campiMancanti';
import { CampoSport, nomiSport, sportDaSalvare, sportDelProdotto } from '../../../../components/Util/sportProdotto';

import chiediConferma from '../../../../components/Util/chiediConferma';
export const CoursesNewClosed = () => {

    const navigate = useNavigate();
    const { profile: profileData } = useProfile({
        autoFetch: true,
        includeTitles: true
    });
    const { getConfirmedMembers, memberships, loading: membershipsLoading } = useMemberships({ autoFetch: true });

    const sdiEnabledNoVat = profileData?.club?.invoiceDataSender?.invoice_enabled === true && !profileData?.club?.invoiceDataSender?.vat_number;
    const billingNotConfirmed = profileData && profileData?.club?.invoiceDataSender?.status !== 'CONFIRMED' && profileData?.club?.profileStatus !== 'INACTIVE';

	const [loadingShowed, setLoadingShowed] = useState(false);


    const [modalCentered, setModalCentered] = useState(false);

    const [tabIndex, setTabIndex] = useState(0);

    const dayOptions = [
        { value: 'MONDAY', label: 'Lunedì' },
        { value: 'TUESDAY', label: 'Martedì' },
        { value: 'WEDNESDAY', label: 'Mercoledì' },
        { value: 'THURSDAY', label: 'Giovedì' },
        { value: 'FRIDAY', label: 'Venerdì' },
        { value: 'SATURDAY', label: 'Sabato' },
        { value: 'SUNDAY', label: 'Domenica' }
    ]

    const [enabledSports, setEnabledSports] = useState([])
    const [availableTeachers, setAvailableTeachers] = useState([])
    const [availableFacilities, setAvailableFacilities] = useState([])
    const [filteredTeachers, setFilteredTeachers] = useState([])
    const [filteredFacilities, setFilteredFacilities] = useState([])

    const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });
    
    // Stati per la gestione dei conflitti
    const [conflictsData, setConflictsData] = useState(null);
    const [loadingConflicts, setLoadingConflicts] = useState(false);
    const [hasConflicts, setHasConflicts] = useState(false);



	useEffect(() => {
        if (profileData && profileData.club && profileData.club.sports) {
            const clubSports = profileData.club.sports.map(s => s.sportType);
            setEnabledSports(sports.filter(element => clubSports.includes(element.value)));
        }

    }, [profileData]);

    useEffect(() => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
    }, []);

    // Load teachers and facilities on page load
    useEffect(() => {
        const fetchTeachersAndFacilities = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    // Wait for memberships to be loaded
                    if (membershipsLoading || !memberships) {
                        console.log('Memberships still loading, waiting...');
                        return;
                    }
                    
                    console.log('Memberships loaded:', memberships.length, 'members');
                    
                    setLoadingShowed(true);
                    const [teachersData, facilitiesData] = await Promise.all([
                        Promise.resolve(getConfirmedMembers('COACH')),
                        apiClient.getVenues(token)
                    ]);
                    setLoadingShowed(false);

                    console.log('Teachers data structure:', teachersData);
                    console.log('Facilities data structure:', facilitiesData);

                    if (teachersData && Array.isArray(teachersData)) {
                        const formattedTeachers = teachersData.map(teacher => ({
                            value: teacher.userId,
                            label: teacher.name,
                            sportType: teacher.sport
                        }));
                        setAvailableTeachers(formattedTeachers);
                    }

                    if (facilitiesData) {
                        // Check if facilitiesData is an array or has a nested structure
                        const facilitiesArray = Array.isArray(facilitiesData) ? facilitiesData : 
                                               (facilitiesData.data && Array.isArray(facilitiesData.data)) ? facilitiesData.data :
                                               (facilitiesData.venues && Array.isArray(facilitiesData.venues)) ? facilitiesData.venues : [];
                        
                        const formattedFacilities = facilitiesArray.map(facility => ({
                            value: facility.id,
                            label: facility.name,
                            sportTypes: sportDelProdotto(facility)
                        }));
                        setAvailableFacilities(formattedFacilities);
                    }
                }
            } catch (error) {
                console.error('Error fetching teachers and facilities:', error);
                setLoadingShowed(false);
            }
        };

        fetchTeachersAndFacilities();
    }, [memberships, membershipsLoading, getConfirmedMembers]);

    // Effetto per chiamare automaticamente checkConflicts quando si completa la programmazione settimanale
    useEffect(() => {
        if (tabIndex === 4) {
            checkConflicts();
        }
    }, [tabIndex]);

    const [formData, setFormData] = useState({
        name: '', 
        sportTypes: [],
        teamName: '',
        maxMembers: 0,
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        vat_rate: 22,
        vat_nature: undefined,
        iva_5_percent: false,
        type: 'CLOSED',
        coachId: '',
        venueId: '',
        newCoursePicture: '',
        startDate: '',
        endDate: '',
        weeklySchedule: []
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };



    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    // Staff e impianti che si possono scegliere: quelli di uno qualsiasi degli sport del corso.
    // Staff e impianto gia' scelti restano se sono ancora di uno degli sport, altrimenti vanno riscelti.
    const cambiaSport = (elenco) => {
        const teachers = availableTeachers.filter(teacher => elenco.includes(teacher.sportType));
        const facilities = availableFacilities.filter(facility => facility.sportTypes.some(s => elenco.includes(s)));
        setFilteredTeachers(teachers);
        setFilteredFacilities(facilities);
        setFormData(prev => ({
            ...prev,
            sportTypes: elenco,
            coachId: teachers.some(t => t.value === prev.coachId) ? prev.coachId : '',
            venueId: facilities.some(f => f.value === prev.venueId) ? prev.venueId : ''
        }));
    };

    // Funzioni per gestire la programmazione settimanale
    const addScheduleItem = () => {
        setFormData({
            ...formData,
            weeklySchedule: [
                ...formData.weeklySchedule,
                {
                    id: Date.now().toString(),
                    dayOfWeek: '',
                    startTime: '',
                    endTime: ''
                }
            ]
        });
    };

    const updateScheduleItem = (index, field, value) => {
        const updatedItems = formData.weeklySchedule.map((item, i) => 
            i === index ? { ...item, [field]: value } : item
        );
        setFormData({ ...formData, weeklySchedule: updatedItems });
    };

    const removeScheduleItem = (index) => {
        const updatedItems = formData.weeklySchedule.filter((_, i) => i !== index);
        setFormData({ ...formData, weeklySchedule: updatedItems });
    };

    // Funzione per controllare i conflitti
    const checkConflicts = async () => {
        try {
            setLoadingConflicts(true);
            
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const conflictRequest = {
                    startDate: formData.startDate,
                    endDate: formData.endDate,
                    weeklySchedule: formData.weeklySchedule,
                    coachId: formData.coachId,
                    venueId: formData.venueId,
                    sport: formData.sportTypes[0]
                };

                const result = await apiClient.checkCourseConflicts(token, conflictRequest);
                
                if (result && !result.error) {
                    setConflictsData(result);
                    setHasConflicts(result.summary && result.summary.conflictSlots > 0);
                } else {
                    console.error('Errore nel controllo conflitti:', result?.error);
                    setModalTitle("Errore");
                    setModalText("Errore durante il controllo dei conflitti. Riprova.");
                    setModalShowed(true);
                }
            }
        } catch (error) {
            console.error('Errore nel controllo conflitti:', error);
            setModalTitle("Errore");
            setModalText("Errore durante il controllo dei conflitti. Riprova.");
            setModalShowed(true);
        } finally {
            setLoadingConflicts(false);
        }
    };

    const formRefs = useRef({});

    const handleDraftSaveClick = () => {
        if (!formData.name || formData.name.trim() === '') {
            // Il campo e' nella prima scheda: ci si torna e poi lo si segnala
            const segnala = () => segnalaMancanti([{ campo: 'course-name', messaggio: 'Manca il nome del corso' }]);
            if (tabIndex !== 0) {
                setTabIndex(0);
                setTimeout(segnala, 150);
            } else {
                segnala();
            }
            return;
        }
        const form = formRefs.current[tabIndex];
        if (form) {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                formData.clubId = tokenDetails.localId;
                formData.status = 'DRAFT';
                saveData();
            }
        }
    };

    const handleSaveClick = (numOfTab, status) => {
        const form = formRefs.current[tabIndex];

        if(numOfTab<6) {
            if (form) {
                const mancanti = [];

                if (numOfTab === 1) {
                    if (!formData.name || formData.name.trim() === '') mancanti.push({ campo: 'course-name', messaggio: 'Manca il nome del corso' });
                    if (!formData.sportTypes.length) mancanti.push({ campo: 'course-sport', messaggio: 'Manca la tipologia di sport' });
                    if (!formData.description || String(formData.description).trim() === '') mancanti.push({ campo: 'course-description', messaggio: 'Manca la descrizione del corso' });
                    if (!formData.newCoursePicture) mancanti.push({ campo: 'course-photo', messaggio: 'Manca la foto del corso' });
                    if (!formData.teamName || formData.teamName.trim() === '') mancanti.push({ campo: 'course-teamName', messaggio: 'Manca il nome della squadra' });
                    const partecipanti = parseInt(formData.maxMembers);
                    if (isNaN(partecipanti) || partecipanti <= 0) mancanti.push({ campo: 'course-maxMembers', messaggio: 'I partecipanti massimi devono essere almeno 1' });
                    if (!formData.coachId) mancanti.push({ campo: 'course-coachId', messaggio: 'Manca lo staff tecnico' });
                    if (!formData.venueId) mancanti.push({ campo: 'course-venueId', messaggio: "Manca l'impianto" });
                }

                if (numOfTab === 2) {
                    const prezzoNonValido = (v) => { const n = parseFloat(v); return isNaN(n) || n <= 0; };
                    if (!priceLocked && prezzoNonValido(formData.standard_price)) mancanti.push({ campo: 'course-standard_price', messaggio: 'Il prezzo standard deve essere maggiore di 0' });
                    if (showingTesseratiOptions && prezzoNonValido(formData.federated_price)) mancanti.push({ campo: 'course-federated_price', messaggio: 'Il prezzo tesserati / soci deve essere maggiore di 0' });
                    const cashback = parseFloat(formData.fitcoin_cashback);
                    if (isNaN(cashback) || cashback < 0) mancanti.push({ campo: 'course-fitcoin_cashback', messaggio: 'Il cashback Fitcoin deve essere maggiore o uguale a 0' });
                }

                if (numOfTab === 3) {
                    // Validazione campi payable nel tab Prezzi
                    if (!formData.payable_in_club && !formData.payable_stripe && !formData.payable_bank) {
                        mancanti.push({ campo: 'switch-payable_in_club', messaggio: 'Attiva almeno una forma di pagamento: in struttura, Stripe o bonifico' });
                    }
                }

                if (numOfTab === 4) {
                    if (!formData.startDate) mancanti.push({ campo: 'course-startDate', messaggio: 'Manca la data di inizio del corso' });
                    if (!formData.endDate) {
                        mancanti.push({ campo: 'course-endDate', messaggio: 'Manca la data di fine del corso' });
                    } else if (formData.startDate && new Date(formData.startDate) >= new Date(formData.endDate)) {
                        mancanti.push({ campo: 'course-endDate', messaggio: 'La data di fine deve essere successiva alla data di inizio' });
                    }
                    if (formData.weeklySchedule.length === 0) {
                        mancanti.push({ campo: 'course-aggiungi-orario', messaggio: 'Aggiungi almeno un orario settimanale' });
                    }
                    // Validazione per ogni elemento della programmazione settimanale
                    formData.weeklySchedule.forEach((item, i) => {
                        if (!item.dayOfWeek) mancanti.push({ campo: `giorno-${i}`, messaggio: 'Manca il giorno della settimana' });
                        if (!item.startTime) mancanti.push({ campo: `inizio-${i}`, messaggio: "Manca l'ora di inizio" });
                        if (!item.endTime) {
                            mancanti.push({ campo: `fine-${i}`, messaggio: "Manca l'ora di fine" });
                        } else if (item.startTime && item.startTime >= item.endTime) {
                            mancanti.push({ campo: `fine-${i}`, messaggio: "L'ora di fine deve essere successiva all'ora di inizio" });
                        }
                    });
                }

                if (segnalaMancanti(mancanti) > 0) return;

                setTabIndex(numOfTab);
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
            }
        } else {

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                formData.clubId = tokenDetails.localId
                formData.status = status
                if(status === 'DRAFT') {
                    saveData();
                } else if(status === 'PURCHASABLE') {
                    saveConfirm();
                }
            }
        }
    };

    // L'immagine viaggia come { content, name }: la si invia solo se ne e' stata
    // scelta una nuova, altrimenti si omette il campo (un content null oppure un
    // oggetto gia' incapsulato faceva fallire lo schema con "must be string").
    const preparePicturePayload = (payload, field) => {
        const current = payload[field];
        const content = typeof current === 'string' ? current : current?.content;
        if (content) {
            payload[field] = {
                content: content,
                name: Math.random().toString(36).substring(2, 10) + (new Date()).getTime().toString(36),
            };
        } else {
            delete payload[field];
        }
    };

    const saveConfirm = () => {
		chiediConferma({ titolo: 'Attivare il corso?', testo: 'La tipologia corso sarà creata e non sarà più possibile modificarne i dati.', conferma: 'Attiva', variante: 'primary' })
		    .then((ok) => { if (ok) saveData(); });
    };

    const saveData = async () => {
        try {

            const payload = { ...formData, ...sportDaSalvare(formData.sportTypes) };

            if(!showingSociOptions) {
                payload.grants_club_membership = false;
                payload.member_price = payload.standard_price;
            }
            if(!showingTesseratiOptions) {
                payload.grants_federated_status = false;
                payload.federated_price = payload.standard_price;
            }

            preparePicturePayload(payload, 'newCoursePicture');

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
                const apiClient = new MyApiClient();

                setLoadingShowed(true);
                const result = await apiClient.createBookingCourse(token, payload);
                setLoadingShowed(false);

                if(result && result.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText(result.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/courses');
                }
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }   
    }

    const saveAndActivate = () => {
        chiediConferma({ titolo: 'Attivare il corso?', testo: 'Il corso sarà creato e attivato subito.', conferma: 'Attiva', variante: 'primary' })
            .then((ok) => { if (ok) saveDataAndActivate(); });
    };

    const saveDataAndActivate = async () => {
        try {
            const payload = { ...formData, ...sportDaSalvare(formData.sportTypes) };

            if(!showingSociOptions) {
                payload.grants_club_membership = false;
                payload.member_price = payload.standard_price;
            }
            if(!showingTesseratiOptions) {
                payload.grants_federated_status = false;
                payload.federated_price = payload.standard_price;
            }

            preparePicturePayload(payload, 'newCoursePicture');

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                setLoadingShowed(true);
                
                // Prima crea il corso come bozza
                payload.clubId = tokenDetails.localId;
                payload.status = 'DRAFT';
                Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
                const createResult = await apiClient.createBookingCourse(token, payload);
                
                if(createResult && createResult.error) {
                    setLoadingShowed(false);
                    setModalTitle("Errore durante l'operazione");
                    setModalText(createResult.error);
                    setModalShowed(true);
                    return;
                }
                
                // Poi attiva il corso
                const activateResult = await apiClient.changeCourseStatus(token, createResult.data.id, 'PURCHASABLE');
                setLoadingShowed(false);
                
                if(activateResult && activateResult.error) {
                    setModalTitle("Errore durante l'attivazione");
                    setModalText(activateResult.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/courses');
                }
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error in saveDataAndActivate: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                setModalTitle("Errore durante l'operazione");
                setModalText(errorResponseData.detail || 'Errore generico');
                setModalShowed(true);
            } else {
                setModalTitle("Errore durante l'operazione");
                setModalText('Errore generico');
                setModalShowed(true);
            }
        }   
    }

    const goBack = (numOfTab) => {
        if(numOfTab>-1) {
            setTabIndex(numOfTab);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
        } else {
            navigate('/struttura/booking/courses');
        }
	};

    const formatData = (value) => {
        if (!value) return '-';
        const d = new Date(value);
        return isNaN(d) ? value : d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    // Campi si'/no: un interruttore su una riga (stessi valori true/false delle vecchie tendine)
    const renderSwitchField = (fieldName, label) => (
        <div className="sid-switch-row">
            <Form.Check
                type="switch"
                id={`switch-${fieldName}`}
                label={label}
                checked={!!formData[fieldName]}
                onChange={(e) => setFormData(prev => ({ ...prev, [fieldName]: e.target.checked }))}
            />
        </div>
    );

    const siNo = (value) => (value ? 'Sì' : 'No');

    const priceLocked = sdiEnabledNoVat || billingNotConfirmed;
    const lockedStyle = { color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" };

	const tabData = [
		{
			id: 'informazioni_generali',
			name: "Informazioni generali",
			icon: <i className="fas fa-info-circle me-2"></i>,
			content: (
                <>
                    <Form ref={el => formRefs.current[0] = el} noValidate>
                        <Card>
                            <Card.Body className="sid-card-body--spaced">
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Label>Nome corso *</Form.Label>
                                        <Form.Control required id="course-name" className="mt-2" type="text" name="name" value={formData.name} onChange={handleChange} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Tipologia di sport *</Form.Label>
                                        <CampoSport
                                            inputId="course-sport"
                                            valore={formData.sportTypes}
                                            onChange={cambiaSport}
                                            opzioni={enabledSports}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label>Descrizione *</Form.Label>
                                        <Form.Control required id="course-description" className="mt-2" rows={10} as="textarea" name="description" value={formData.description || ''} onChange={handleChange} />
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label>Foto *</Form.Label>
                                        <div className="sid-photo-field">
                                            <div className="sid-photo-field__preview">
                                                {formData.newCoursePicture ?
                                                    <img src={`data:image/jpeg;base64,${formData.newCoursePicture}`} alt="" />
                                                :
                                                    <span>Nessuna foto</span>
                                                }
                                            </div>
                                            <Button id="course-photo" size="sm" variant="outline-dark" onClick={() => setModalCentered(true)}>
                                                {formData.newCoursePicture ? 'Sostituisci foto' : 'Carica foto'}
                                            </Button>
                                            {formData.newCoursePicture && (
                                                <Button size="sm" variant="outline-danger" onClick={handleRemoveImage}>
                                                    Rimuovi
                                                </Button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                <h5 className="sid-form-section">Squadra</h5>
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Label>Nome della squadra *</Form.Label>
                                        <Form.Control required id="course-teamName" className="mt-2" type="text" name="teamName" value={formData.teamName} onChange={handleChange} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Partecipanti massimi *</Form.Label>
                                        <Form.Control required id="course-maxMembers" className="mt-2" type="number" name="maxMembers" value={formData.maxMembers} onChange={handleChange} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Staff tecnico *</Form.Label>
                                        <Select
                                            required
                                            inputId="course-coachId"
                                            className="mt-2"
                                            styles={sidSelectStyles}
                                            name="coachId"
                                            value={filteredTeachers.find(option => option.value === formData.coachId) || null}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "coachId")}
                                            options={filteredTeachers}
                                            isDisabled={!formData.sportTypes.length || filteredTeachers.length === 0}
                                        />
                                        {!formData.sportTypes.length && <Form.Text className="text-muted">Scegli prima la tipologia di sport</Form.Text>}
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Impianto *</Form.Label>
                                        <Select
                                            required
                                            inputId="course-venueId"
                                            className="mt-2"
                                            styles={sidSelectStyles}
                                            name="venueId"
                                            value={filteredFacilities.find(option => option.value === formData.venueId) || null}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "venueId")}
                                            options={filteredFacilities}
                                            isDisabled={!formData.sportTypes.length || filteredFacilities.length === 0}
                                        />
                                        {!formData.sportTypes.length && <Form.Text className="text-muted">Scegli prima la tipologia di sport</Form.Text>}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <div className="d-flex justify-content-end gap-4 mt-4">
                            <button type="button" className="btn btn-dark light" onClick={() => goBack(-1)}>Annulla</button>
                            <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                            <button type="button" onClick={() => handleSaveClick(1, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                        </div>
                    </Form>
                </>
			),
		},
		{
			id: 'prezzi',
			name: "Prezzi",
			icon: <DollarSquare size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[1] = el} noValidate>
                                <Row className="g-4">
                                    <Col md={3}>
                                        <Form.Label>Prezzo standard *</Form.Label>
                                        <Form.Control required id="course-standard_price" disabled={priceLocked} className="mt-2" style={priceLocked ? lockedStyle : undefined} type="text" name="standard_price" value={formData.standard_price} onChange={handleChange} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label>IVA</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            styles={sidSelectStyles}
                                            isDisabled={priceLocked}
                                            name="vat_rate"
                                            value={findVatOption(formData)}
                                            onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
                                            options={VAT_OPTIONS}
                                        />
                                    </Col>
                                    {showingTesseratiOptions &&
                                    <Col md={3}>
                                        <Form.Label>Prezzo tesserati / soci *</Form.Label>
                                        <Form.Control required id="course-federated_price" className="mt-2" type="text" name="federated_price" value={formData.federated_price} onChange={handleChange} />
                                    </Col>
                                    }
                                    <Col md={3}>
                                        <Form.Label>Cashback Fitcoin *</Form.Label>
                                        <Form.Control required id="course-fitcoin_cashback" className="mt-2" type="text" name="fitcoin_cashback" value={formData.fitcoin_cashback} onChange={handleChange} />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>

                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(0)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                        <button type="button" onClick={() => handleSaveClick(2, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'condizioni_aggiuntive',
			name: "Condizioni aggiuntive",
			icon: <CardAdd size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[2] = el} noValidate>
                                <div className="sid-switch-inline">
                                    {renderSwitchField('payable_in_club', 'Acquisto pagabile in struttura')}
                                    {paymentMethods.stripe_enabled && renderSwitchField('payable_stripe', 'Acquisto pagabile su Stripe')}
                                    {paymentMethods.bank_transfer_enabled && renderSwitchField('payable_bank', 'Acquisto pagabile con bonifico')}
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(1)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                        <button type="button" onClick={() => handleSaveClick(3, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'programmazione',
			name: "Programmazione",
			icon: <Calendar size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[5] = el} noValidate>
                                <Row className="g-4">
                                    <Col md={3}>
                                        <Form.Label>Data inizio *</Form.Label>
                                        <Form.Control required id="course-startDate" className="mt-2" type="date" name="startDate" value={formData.startDate} onChange={handleChange} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label>Data fine *</Form.Label>
                                        <Form.Control required id="course-endDate" className="mt-2" type="date" name="endDate" value={formData.endDate} onChange={handleChange} />
                                    </Col>
                                </Row>

                                <h5 className="sid-form-section">Orari settimanali *</h5>
                                {formData.weeklySchedule.map((item, index) => (
                                    <Row key={item.id || index} className="g-3 mb-3 align-items-end">
                                        <Col md={4}>
                                            <Form.Label>Giorno *</Form.Label>
                                            <Select
                                                inputId={`giorno-${index}`}
                                                className="mt-2"
                                                styles={sidSelectStyles}
                                                value={dayOptions.find(option => option.value === item.dayOfWeek) || null}
                                                onChange={(selectedOption) => updateScheduleItem(index, 'dayOfWeek', selectedOption?.value || '')}
                                                options={dayOptions}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Form.Label>Ora inizio *</Form.Label>
                                            <Form.Control
                                                id={`inizio-${index}`}
                                                className="mt-2"
                                                type="time"
                                                value={item.startTime}
                                                onChange={(e) => updateScheduleItem(index, 'startTime', e.target.value)}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Form.Label>Ora fine *</Form.Label>
                                            <Form.Control
                                                id={`fine-${index}`}
                                                className="mt-2"
                                                type="time"
                                                value={item.endTime}
                                                onChange={(e) => updateScheduleItem(index, 'endTime', e.target.value)}
                                            />
                                        </Col>
                                        <Col md={2} className="d-flex justify-content-end">
                                            <Button
                                                variant="outline-danger"
                                                size="sm"
                                                title="Rimuovi orario"
                                                onClick={async () => { if (await chiediConferma({ titolo: 'Rimuovere l\'orario?', testo: 'L\'orario sparisce dalla programmazione settimanale.' })) removeScheduleItem(index); }}
                                            >
                                                <Trash size="14" />
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}

                                {formData.weeklySchedule.length === 0 && (
                                    <div className="sid-readonly-value mb-3">Nessun orario configurato</div>
                                )}

                                <div>
                                    <Button id="course-aggiungi-orario" variant="outline-dark" size="sm" onClick={addScheduleItem}>
                                        <Add size="14" className="me-1" />
                                        Aggiungi orario
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(2)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                        <button type="button" onClick={() => handleSaveClick(4, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'conflitti',
			name: "Conflitti",
			icon: <Warning2 size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[4] = el} noValidate>
                                <Row>
                                    <Col className="col-xl-12">
                                        {loadingConflicts ? (
                                            <div className="text-center py-4">
                                                <Spinner animation="border" role="status">
                                                    <span className="visually-hidden">Caricamento...</span>
                                                </Spinner>
                                                <p className="mt-2">Controllo conflitti in corso...</p>
                                            </div>
                                        ) : conflictsData ? (
                                            <div>
                                                {/* Riepilogo conflitti */}
                                                {conflictsData.summary && (
                                                    <div className={`alert ${hasConflicts ? 'alert-warning' : 'alert-success'}`} role="alert">
                                                        <Warning2 variant="Bulk" className="me-2" />
                                                        <strong>
                                                            {hasConflicts 
                                                                ? `Trovati ${conflictsData.summary.conflictSlots} conflitti su ${conflictsData.summary.totalSlots} slot`
                                                                : 'Nessun conflitto rilevato'
                                                            }
                                                        </strong>
                                                    </div>
                                                )}
                                                
                                                {/* Programmazione settimanale con evidenziazione conflitti */}
                                                <div className="mt-3">
                                                    {console.log('Debug conflictsData:', conflictsData)}
                                                    {conflictsData && conflictsData.slots && conflictsData.slots.length > 0 ? (
                                                        <div className="table-responsive">
                                                            <table className="table">
                                                                <thead className="table-dark">
                                                                    <tr>
                                                                        <th className="text-black">Giorno</th>
                                                                        <th className="text-black">Orario</th>
                                                                        <th className="text-center text-black" style={{width: '50%'}}>Stato</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {conflictsData.slots.map((slot, index) => {
                                                                        const dayLabel = dayOptions.find(d => d.value === slot.dayOfWeek)?.label || slot.dayOfWeek;
                                                                        
                                                                        // Verifica se questo slot ha conflitti dalla risposta API
                                                                        const hasSlotConflict = !slot.isValid;
                                                                        const conflictReasons = [];
                                                                        
                                                                        if (slot.venueConflict?.hasConflict) {
                                                                            conflictReasons.push(slot.venueConflict.reason || 'Conflitto struttura');
                                                                        }
                                                                        if (slot.coachConflict?.hasConflict) {
                                                                            conflictReasons.push(slot.coachConflict.reason || 'Conflitto maestro');
                                                                        }
                                                                        
                                                                        const conflictMessage = conflictReasons.join('; ');
                                                                        
                                                                        return (
                                                                            <tr key={index} className={hasSlotConflict ? '' : ''} style={hasSlotConflict ? {backgroundColor: '#f8d7da'} : {backgroundColor: '#f8f9fa'}}>
                                                                                <td className="fw-medium">
                                                                                    <span className="badge bg-primary me-2">{dayLabel.substring(0, 3).toUpperCase()}</span>
                                                                                    <small>
                                                                                        {slot.date ? new Date(slot.date).toLocaleDateString('it-IT', {
                                                                                            day: '2-digit',
                                                                                            month: '2-digit',
                                                                                            year: 'numeric'
                                                                                        }) : 'N/A'}
                                                                                    </small>
                                                                                </td>
                                                                                <td className="fw-medium">
                                                                                    <i className="fa fa-clock text-muted me-2"></i>
                                                                                    {slot.startTime} - {slot.endTime}
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    {hasSlotConflict ? (
                                                                                        <div>
                                                                                            <span className="badge bg-danger fs-6 mb-1">
                                                                                                <i className="fa fa-exclamation-triangle me-1"></i>
                                                                                                CONFLITTO
                                                                                            </span>
                                                                                            {conflictMessage && (
                                                                                                <div className="small text-danger mt-1">
                                                                                                    <strong>Motivo:</strong> {conflictMessage}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    ) : (
                                                                                        <span className="badge bg-success fs-6">
                                                                                            <i className="fa fa-check me-1"></i>
                                                                                            DISPONIBILE
                                                                                        </span>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="alert alert-warning" role="alert">
                                                            <Warning2 variant="Bulk" className="me-2" />
                                                            <strong>Nessuno slot trovato per il controllo conflitti</strong>
                                                            <br />
                                                            <small className="text-muted">
                                                                Assicurati di aver compilato la programmazione settimanale nel tab precedente.
                                                                {conflictsData && conflictsData.slots ? `Trovati ${conflictsData.slots.length} slot.` : 'Dati conflitti non disponibili.'}
                                                            </small>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="text-center py-4">
                                                <div className="alert alert-info" role="alert">
                                                    <Information variant="Bulk" className="me-2" />
                                                    <strong>Controllo conflitti in attesa...</strong>
                                                    <br />
                                                    <small>Completa la programmazione settimanale nel tab precedente per visualizzare l'analisi dei conflitti</small>
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(3)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                        <button type="button" 
                            onClick={hasConflicts ? undefined : () => handleSaveClick(5, 'DRAFT')} 
                            className={`btn btn-primary ${hasConflicts ? 'disabled' : ''}`}
                            style={hasConflicts ? { pointerEvents: 'none', opacity: 0.6 } : {}}
                        >
                            Avanti
                        </button>
                    </div>
                </>
			),
		},
		{
			id: 'riepilogo',
			name: "Riepilogo e conferma",
			icon: <Judge size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Body className="sid-card-body--spaced">
                            <Form ref={el => formRefs.current[3] = el} noValidate>
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Label>Nome corso</Form.Label>
                                        <div className="sid-readonly-value">{formData.name || '-'}</div>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Tipologia di sport</Form.Label>
                                        <div className="sid-readonly-value">{nomiSport(formData) || '-'}</div>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label>Descrizione</Form.Label>
                                        <div className="sid-readonly-value" style={{ whiteSpace: 'pre-wrap' }}>{formData.description || '-'}</div>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label>Foto</Form.Label>
                                        <div className="sid-photo-field">
                                            <div className="sid-photo-field__preview">
                                                {formData.newCoursePicture ?
                                                    <img src={`data:image/jpeg;base64,${formData.newCoursePicture}`} alt="" />
                                                :
                                                    <span>Nessuna foto</span>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                <h5 className="sid-form-section">Prezzi</h5>
                                <Row className="g-4">
                                    <Col md={3}>
                                        <Form.Label>Prezzo standard</Form.Label>
                                        <div className="sid-readonly-value">{formData.standard_price}</div>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label>IVA</Form.Label>
                                        <div className="sid-readonly-value">{findVatOption(formData)?.label || '-'}</div>
                                    </Col>
                                    {showingTesseratiOptions &&
                                    <Col md={3}>
                                        <Form.Label>Prezzo tesserati / soci</Form.Label>
                                        <div className="sid-readonly-value">{formData.federated_price}</div>
                                    </Col>
                                    }
                                    <Col md={3}>
                                        <Form.Label>Cashback Fitcoin</Form.Label>
                                        <div className="sid-readonly-value">{formData.fitcoin_cashback}</div>
                                    </Col>
                                </Row>

                                <h5 className="sid-form-section">Forme di pagamento</h5>
                                <Row className="g-4">
                                    <Col md={4}>
                                        <Form.Label>Pagabile in struttura</Form.Label>
                                        <div className="sid-readonly-value">{siNo(formData.payable_in_club)}</div>
                                    </Col>
                                    {paymentMethods.stripe_enabled && (
                                    <Col md={4}>
                                        <Form.Label>Pagabile su Stripe</Form.Label>
                                        <div className="sid-readonly-value">{siNo(formData.payable_stripe)}</div>
                                    </Col>
                                    )}
                                    {paymentMethods.bank_transfer_enabled && (
                                    <Col md={4}>
                                        <Form.Label>Pagabile con bonifico</Form.Label>
                                        <div className="sid-readonly-value">{siNo(formData.payable_bank)}</div>
                                    </Col>
                                    )}
                                </Row>

                                <h5 className="sid-form-section">Squadra</h5>
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Label>Nome della squadra</Form.Label>
                                        <div className="sid-readonly-value">{formData.teamName || '-'}</div>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Partecipanti massimi</Form.Label>
                                        <div className="sid-readonly-value">{formData.maxMembers}</div>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Staff tecnico</Form.Label>
                                        <div className="sid-readonly-value">{availableTeachers.find(option => option.value === formData.coachId)?.label || '-'}</div>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Impianto</Form.Label>
                                        <div className="sid-readonly-value">{availableFacilities.find(option => option.value === formData.venueId)?.label || '-'}</div>
                                    </Col>
                                </Row>

                                <h5 className="sid-form-section">Programmazione</h5>
                                <Row className="g-4">
                                    <Col md={3}>
                                        <Form.Label>Data inizio</Form.Label>
                                        <div className="sid-readonly-value">{formatData(formData.startDate)}</div>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label>Data fine</Form.Label>
                                        <div className="sid-readonly-value">{formatData(formData.endDate)}</div>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Orari settimanali</Form.Label>
                                        {formData.weeklySchedule && formData.weeklySchedule.length > 0 ? (
                                            <ul className="sid-schedule-list">
                                                {formData.weeklySchedule.map((item, index) => (
                                                    <li key={item.id || index}>
                                                        <span>{dayOptions.find(option => option.value === item.dayOfWeek)?.label || item.dayOfWeek}</span>
                                                        <span>{item.startTime} – {item.endTime}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <div className="sid-readonly-value">Nessun orario configurato</div>
                                        )}
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>

                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(4)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleSaveClick(6, 'DRAFT')} className="btn btn-secondary">Salva come bozza</button>
                        {!billingNotConfirmed && <button type="button" onClick={() => saveAndActivate()} className="btn btn-primary">Salva e attiva</button>}
                    </div>
                </>
			),
		}
	];

    function handleRemoveImage() {
        setFormData({
            ...formData,
            newCoursePicture: null
        });
    }

	return (
		<>
			<ProductImageUploader
                show={modalCentered}
                onClose={() => setModalCentered(false)}
                onSave={(base64String) => {
                    setModalCentered(false);
                    setFormData({
                        ...formData,
                        newCoursePicture: base64String
                    });
                }}
                titolo="Immagine del corso"
            />


			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			{billingNotConfirmed && (
				<AvvisoFatturazione />
			)}

			<div className="custom-tab-1">
                <Tab.Container activeKey={tabData[tabIndex]?.id.toLowerCase()}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link onClick={(e) => e.preventDefault()} eventKey={data.id.toLowerCase()} style={{ cursor: 'default', pointerEvents: 'none' }}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-12">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
						</div>
					</Row>
				</Tab.Container>
			</div>
		</>
	)
}
export default CoursesNewClosed;